import React, { useState, useRef, useEffect } from "react";
import JoditEditor from "jodit-react";
import { getContentApi, updateContentApi } from "services/cms";
import { toastMessage } from "utils/toastMessage";
import { CustomModal } from "components/modals/ModalBox";
import "./ContentManagement.scss";
import useButtonLoader from "hooks/useButtonLoader";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaPencilAlt, FaPlus } from "react-icons/fa";

const ContentManagement = () => {
  const editor = useRef(null);
  const [contentData, setContentData] = useState({});
  const [selectedKey, setSelectedKey] = useState("");
  const [isModalOpen, setIsModalOpen] = useState({ modal: false, id: '' });
  const [editorContent, setEditorContent] = useState("");
  const [buttonLoader, setButtonLoader] = useButtonLoader("Save");
  const [loader, onShow, onHide] = useFullPageLoader();

  // Predefined content types
  const keys = [
    { key: "aboutUs", label: "About Us" },
    { key: "terms", label: "Terms & Conditions" },
    { key: "privacy", label: "Privacy Policy" },
  ];
  // -----------fetch-CMS-----------------------
  const fetchContent = async () => {
    try {
      onShow();
      const res = await getContentApi();
      const { code, data } = res?.data;
      if (code === 200) {
        const result = data?.data?.reduce((acc, { type, description, _id }) => {
          acc[type] = { description, id: _id }
          return acc;
        }, {});

        setContentData(result);
      }
    } catch (error) {
      console.error("Error fetching content:", error.message);
    } finally {
      onHide();
    }
  };



  // Open the modal and set the content for the selected key
  const openEditor = (key) => {
    // console.log('key', key)
    setSelectedKey(key);
    setEditorContent(contentData[key]?.description || "");
    setIsModalOpen({ modal: true, id: contentData[key]?.id || "" });
  };
  // --------close-modal------------
  const closeModal = () => {
    setIsModalOpen({ ...isModalOpen, modal: false });
  };
  // // Handle content update
  const updateContent = async () => {
    setButtonLoader(true);
    try {
      const reqData = {
        ...(isModalOpen?.id && { _id: isModalOpen?.id }),
        type: selectedKey,
        description: editorContent,
      };
      const res = await updateContentApi(reqData);
      console.log('res', res)
      const { code, data } = res?.data;
      console.log('updateContent data', data)
      if (code === 200) {
        toastMessage(data?.message, "success", "contentUpdate");
        setContentData((prev) => ({
          ...prev,
          [selectedKey]: {
            ...prev[selectedKey],
            description: editorContent
          },
        }));
        closeModal()
      }
    } catch (error) {
      console.error("Error updating content:", error.message);
    } finally {
      setButtonLoader(false);
    }
  };
  // Fetch all content data
  useEffect(() => {
    fetchContent();
  }, []);
  return (
    <>
      <div className="content_management">
        <div className="page_title">
          <h3>Content Management</h3>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="contentManagement">
              <div className="content-grid">
                {loader}
                {keys.map(({ key, label }) => (
                  <div key={key} className="content-card">
                    <h4>{label}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: contentData[key]?.description || "No content available",
                      }}
                    />
                    <button
                      className="edit-button "
                      onClick={() => openEditor(key)}
                    >
                      {
                        contentData[key]?.description ? (
                          <>
                            <FaPencilAlt />
                            Edit
                          </>
                        ) : (
                          <>
                            <FaPlus /> Add
                          </>
                        )
                      }
                    </button>
                  </div>
                ))}
              </div>
              {/* Custom Modal for editing or adding content */}
              <CustomModal
                show={isModalOpen?.modal}
                handleClose={closeModal}
                className="lg edit_content_modal"
                size="lg"
              >
                <h3>
                  {contentData[selectedKey]?.description
                    ? `Edit ${keys.find((item) => item.key === selectedKey)?.label
                    }`
                    : `Add ${keys.find((item) => item.key === selectedKey)?.label
                    }`}
                </h3>
                <JoditEditor
                  ref={editor}
                  value={editorContent}
                  tabIndex={1}
                  onBlur={(newContent) => setEditorContent(newContent)}
                  config={{
                    readonly: false,
                    height: 300,
                    placeholder: "Edit content here...",
                  }}
                />
                <div className="button_wrap">
                  <button
                    type="button"
                    className="button light"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="button"
                    onClick={updateContent}
                    ref={buttonLoader}
                  >
                    Save
                  </button>
                </div>
              </CustomModal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentManagement;
